/* App loading after the page is usable.

   One release point for third-party app work:
   - fires 'pa:apps-ready', which starts Shopify's legacy ScriptTag loader
     (asyncLoad - NoFraud, Instafeed; re-pointed in layout/theme.liquid);
   - promotes <div data-lazy-embed><template data-lazy-embed>...</template></div>
     wrappers (app blocks). A <template> is inert, so nothing inside it fetches
     or runs until it is cloned into the page.

   Release happens once, after window load: on the first scroll, touch,
   pointer/mouse movement or keypress, or 10s after load if there is none.
   Lab tools (GTmetrix/Lighthouse) never interact, and a shorter fallback
   landed NoFraud's ~1s task inside their measuring window; real visitors
   almost always interact long before 10s.
   Reaching a specific embed (pointer, touch or keyboard focus) promotes it
   straight away. Embeds are promoted one per task so no single long task. */
(function () {
  'use strict';

  var FALLBACK_MS = 10000;
  var released = false;
  var interacted = false;
  var loaded = document.readyState === 'complete';

  function promote(container, focusAfter) {
    if (!container || container.dataset.paLazyDone) return;
    var template = container.querySelector('template[data-lazy-embed]');
    if (!template) return;
    container.dataset.paLazyDone = 'true';
    template.replaceWith(template.content.cloneNode(true));
    if (focusAfter) {
      var focusable = container.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    }
  }

  function promoteAll() {
    var containers = Array.prototype.slice.call(document.querySelectorAll('div[data-lazy-embed]:not([data-pa-lazy-done])'));
    (function step() {
      var container = containers.shift();
      if (!container) return;
      promote(container, false);
      if (containers.length) setTimeout(step, 0);
    })();
  }

  function release() {
    if (released) return;
    released = true;
    window.dispatchEvent(new Event('pa:apps-ready'));
    promoteAll();
  }

  function onInteract() {
    interacted = true;
    if (loaded) release();
  }

  function onLoaded() {
    loaded = true;
    if (interacted) release();
    else setTimeout(release, FALLBACK_MS);
  }

  function onScopedTrigger(event) {
    promote(event.currentTarget, event.type === 'focusin');
  }

  function watch(container) {
    if (container.dataset.paLazyWatched) return;
    container.dataset.paLazyWatched = 'true';
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
      container.addEventListener(type, onScopedTrigger, { once: true, passive: true });
    });
    if (released) promote(container, false);
  }

  Array.prototype.forEach.call(document.querySelectorAll('div[data-lazy-embed]'), watch);

  ['scroll', 'touchstart', 'pointermove', 'mousemove', 'keydown'].forEach(function (type) {
    window.addEventListener(type, onInteract, { once: true, passive: true });
  });

  if (loaded) onLoaded();
  else window.addEventListener('load', onLoaded, { once: true });

  // Containers added later (AJAX-rendered sections) are wired up the same way.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('div[data-lazy-embed]')) watch(node);
          if (node.querySelectorAll) Array.prototype.forEach.call(node.querySelectorAll('div[data-lazy-embed]'), watch);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
